.terminalOutput {
    flex-grow: 1;
    padding: 1.5rem;
    overflow-y: auto;
    font-family: var(--font-code);
    font-size: 0.875rem;
    color: var(--text-secondary);
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    cursor: text;
    -webkit-mask-image: linear-gradient(to bottom, transparent 0px, black 40px, black 100%);
    mask-image: linear-gradient(to bottom, transparent 0px, black 40px, black 100%);
}

.terminalOutput > :first-child {
    margin-top: auto;
}

.termLine {
    display: flex;
    gap: 0.5rem;
    line-height: 1.5;
    word-break: break-all;
}

.termPrefix { color: rgba(0, 240, 255, 0.6); }
.termSuccess { color: var(--accent-cyan); }
.termText { color: var(--text-primary); }
.termDim { color: var(--text-secondary); }
.termFaded { opacity: 0.5; }
.termError { color: var(--accent-magenta); }

.termClickable {
    cursor: pointer;
    text-decoration: underline;
    text-underline-offset: 3px;
    transition: color 0.2s, text-shadow 0.2s;
}

.termClickable:hover {
    color: var(--accent-cyan);
    text-shadow: 0 0 5px rgba(0, 240, 255, 0.5);
}

.inputContainer {
    padding: 1rem;
    border-top: 1px solid var(--border);
    background-color: var(--bg-surface);
    margin-top: auto;
    display: flex;
    align-items: center;
    gap: 0.75rem;
    cursor: text;
}

.inputPrompt {
    font-family: var(--font-code);
    color: var(--accent-green);
    white-space: nowrap;
}

.inputWrapper {
    flex-grow: 1;
    display: flex;
    align-items: center;
    position: relative;
    font-family: var(--font-code);
    font-size: 0.875rem;
    color: var(--accent-cyan);
}

.inputText {
    color: var(--accent-cyan);
    white-space: pre;
}

.hiddenInput {
    position: absolute;
    left: -9999px;
    opacity: 0;
    border: none;
    padding: 0;
    margin: 0;
}

.cursor {
    animation: blink 1s step-end infinite;
    color: var(--accent-cyan);
    margin-left: 2px;
}

.execButton {
    font-family: var(--font-code);
    font-size: 0.75rem;
    color: var(--bg-primary);
    background-color: var(--accent-cyan);
    padding: 0.25rem 0.5rem;
    border-radius: 2px;
    text-transform: uppercase;
    pointer-events: none;
}
